import { useParams } from "react-router-dom";
import logoLight from "../assets/SONGIMPLI-LOGO.svg";
import logoDark from "../assets/SONGIMPLI-LOGO-DARK.svg";
import {
  getDashboardUrl,
  isUserLoggedIn,
  resolveAppLocale,
} from "../utils/helper";

interface SongSimpliLogoProps {
  isDark?: boolean;
  alt?: string;
  wrapperClassName?: string;
  imgClassName?: string;
}

export default function SongSimpliLogo({
  isDark = false,
  alt = "SongSimpli",
  wrapperClassName = "relative h-10 w-[120px] sm:h-[40px] sm:w-[200px]",
  imgClassName = "block h-full w-full object-contain",
}: SongSimpliLogoProps) {
  const { locale } = useParams<{ locale?: string }>();
  const loggedIn = isUserLoggedIn();

  function handleLogoClick() {
    if (!loggedIn) return;
    window.location.assign(getDashboardUrl(locale ?? resolveAppLocale()));
  }

  if (!loggedIn) {
    return (
      <div className={wrapperClassName}>
        <img
          alt={alt}
          className={imgClassName}
          src={isDark ? logoDark : logoLight}
        />
      </div>
    );
  }

  return (
    <button
      type="button"
      aria-label="Go to dashboard"
      className={`${wrapperClassName} cursor-pointer border-0 bg-transparent p-0 text-left`}
      onClick={handleLogoClick}
    >
      <img
        alt={alt}
        className={imgClassName}
        src={isDark ? logoDark : logoLight}
      />
    </button>
  );
}
